module.exports = __webpack_public_path__ + "img/play-outline-green.7b49fc14.svg";